exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand-enter-active,\n.expand-leave-active {\n  overflow: hidden;\n  transition: max-height 0.5s ease-out;\n  height: auto;\n  max-height: 1000px;\n  transform-origin: top;\n}\n.expand-leave-active {\n  max-height: 0;\n}\n", ""]);

// exports
